import { Box, Switch, Typography } from "@mui/material";
import React from "react";
import { useUser } from "../contexts/useUser";
import { updateLLMProjectStatus } from "../dataaccess/updateProjectStatus";
import { useQueryClient } from "@tanstack/react-query";

const ProjectControlPanel: React.FC = () => {
  const { project } = useUser();
  const queryClient = useQueryClient();

  const sheddingTierToText = (tier: number) => {
    switch (project?.loadSheddingTier) {
      case 0:
        return "Responding to all customers";
      case 1:
        return "Responding to Tier 2, 3 & 4 customers";
      case 2:
        return "Responding to Tier 3 & 4 customers";
      case 3:
        return "Responding to Tier 4 customers";
      default:
        return "Unknown";
    }
  };

  if (!project) {
    return <Box>Loading...</Box>;
  }

  return (
    <Box>
      <Box p={2} display="flex" flexDirection={"row"}>
        <Box
          p={2}
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          sx={{
            color: project?.loadBalancingMode !== "off" ? "ButtonFace" : "red",
          }}
        >
          <Typography variant="h6">Load Balancing</Typography>
          <Typography variant="h6">
            {project?.loadBalancingMode === "off" ? "OFF" : "ON"}
          </Typography>

          <Typography variant="caption">
            {project?.loadBalancingMode} method
          </Typography>
        </Box>
        <Box
          p={2}
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          sx={{
            color:
              (project?.cacheResponsesForSeconds ?? 0) > 0
                ? "ButtonFace"
                : "red",
          }}
        >
          <Typography variant="h6">Caching</Typography>
          <Typography variant="h6">
            {(project?.cacheResponsesForSeconds ?? 0) < 1 ? "OFF" : "ON"}
          </Typography>
          {(project?.cacheResponsesForSeconds ?? 0) > 0 && (
            <Typography variant="caption">
              {project?.cacheResponsesForSeconds} seconds
            </Typography>
          )}
        </Box>
        <Box
          p={2}
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          sx={{
            color:
              project?.newCustomerTokenCount ?? 0 < 1 ? "ButtonFace" : "red",
          }}
        >
          <Typography variant="h6">New Customers</Typography>
          <Typography variant="h6">
            {(project?.newCustomerTokenCount ?? 0) < 1 ? "OFF" : "ON"}
          </Typography>
          {(project?.newCustomerTokenCount ?? 0) > 0 && (
            <Typography variant="caption">
              {project?.newCustomerTokenCount} tokens
            </Typography>
          )}
        </Box>
        <Box
          p={2}
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          sx={{ color: project?.loadSheddingTier === 0 ? "ButtonFace" : "red" }}
        >
          <Typography variant="h6">Load Shedding</Typography>
          <Typography variant="h6">
            {project?.loadSheddingTier === 0 ? "OFF" : "ON"}
          </Typography>

          <Typography variant="caption">
            {sheddingTierToText(project?.loadSheddingTier ?? 0)}
          </Typography>
        </Box>
        <Box
          p={2}
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          sx={{
            color: project?.maintenanceMode === false ? "ButtonFace" : "red",
          }}
        >
          <Typography variant="h6">Maintenance Mode</Typography>
          <Typography variant="h6">
            {project?.maintenanceMode ? "ON" : "OFF"}
          </Typography>

          <Typography variant="caption">
            {project?.maintenanceMode ? "Sending message" : ""}
          </Typography>
        </Box>
        <Box
          p={2}
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          sx={{
            border: 1,
            width: 225,
            color: project?.status === "active" ? "ButtonFace" : "red",
          }}
        >
          <Typography variant="h6">Master Switch</Typography>
          <Box>
            <Typography variant="caption">OFF</Typography>
            <Switch
              size="medium"
              checked={project?.status === "active"}
              onChange={async () => {
                await updateLLMProjectStatus(
                  project?.id ?? "unknown",
                  project?.status === "active" ? "disabled" : "active"
                );
                queryClient.invalidateQueries({ queryKey: ["projects"] });
              }}
            />
            <Typography variant="caption">ON (allow traffic)</Typography>
          </Box>
          <Typography variant="caption">Status: {project?.status}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectControlPanel;
